import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const FormListInputElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form List Input',
  icon: 'DocumentTextIcon',
  description: 'Adds a list input form control',
  properties: [
    'layout',
    {
      label: 'Checked List',
      name: 'checkedList',
      editor: 'switch',
      description: 'Show each list item as a checkbox',
      default: false,
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Default Value',
      name: 'defaultValue',
      editor: 'textbox',
      description: 'Default value',
      default: ' ',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Labels',
      name: 'labels',
      editor: 'textbox',
      description: 'The labels of items that will appear in the list',
      default: ' ',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Values',
      name: 'values',
      editor: 'textbox',
      description: 'The values of items that will appear in the list',
      default: ' ',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'color',
    'alignment',
    'margin',
    {
      label: 'Padding',
      name: 'padding',
      editor: 'boundary',
      description: 'The padding within the input',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    'width',
    {
      label: 'Size',
      name: 'size',
      editor: 'number',
      description: 'The number of items in the list',
      default: '10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    }
  ]
};

export default FormListInputElementFields;
